var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"10","height":"8","viewBox":"0 0 10 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M8.62633 0.816406L5 4.44273L1.37367 0.816406L0 2.19008L5 7.19008L10 2.19008L8.62633 0.816406Z","fill":"currentColor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }